/*
 * Purpose: Format mission dossier for AI prompts — dropbox read-only context
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */
import type { MissionDossierEntry } from './types';
import { MISSION_DOSSIER_DROPBOX_NOTICE } from './types';

const MAX_ENTRIES = 40;
const MAX_CHARS = 14_000;

function formatEntry(e: MissionDossierEntry): string {
  const lines = [`[${e.seq}] ${e.at} · ${e.actor}/${e.kind}: ${e.summary}`];
  if (e.reasoning?.trim()) lines.push(`  reasoning: ${e.reasoning.trim()}`);
  if (e.action?.trim()) lines.push(`  action: ${e.action.trim()}`);
  return lines.join('\n');
}

export function formatMissionDossierForAi(entries: readonly MissionDossierEntry[]): string | undefined {
  if (entries.length === 0) return undefined;

  const tail = entries.slice(-MAX_ENTRIES);
  const body = tail.map(formatEntry).join('\n');
  const block = `${MISSION_DOSSIER_DROPBOX_NOTICE}\n\n${body}`;

  if (block.length <= MAX_CHARS) return block;
  return `${MISSION_DOSSIER_DROPBOX_NOTICE}\n\n${body.slice(-MAX_CHARS)}`;
}

export function formatMissionDossierForDisplay(entries: readonly MissionDossierEntry[]): string {
  if (entries.length === 0) return '(empty — first AI action will append here)';
  return entries.map(formatEntry).join('\n\n');
}
